<template>
  <div id="signup-page">
    <div id=signup-header>
      <h1>Fire Watch 101 New Account</h1>
      <v-card-text>Already have an account?<v-btn color="info" :to="{path: 'login'}" text>Log In</v-btn></v-card-text>
    </div>
    <v-app id="inspire">
      <div id=signup-form>
        <v-form ref="signup" v-model="valid" lazy-validation>
          <v-text-field v-model="firstname" :rules="firstnameRules" label="First Name" required> </v-text-field>
          <v-text-field v-model="lastname" :rules="lastnameRules" label="Last Name" required> </v-text-field>
          <v-text-field autocorrect="off" autocapitalize="none" v-model="email" :rules="emailRules" label="Email Address" required> </v-text-field>
          <v-text-field v-model="zipcode" :rules="zipcodeRules" label="Zip Code" :counter="5" required> </v-text-field>
          <v-select v-model="whoRU" :items="whoRUitems" :rules="whoRUrules" label="Select the Option Which Discribes You Best" data-vv-name="select" required></v-select>
          <v-text-field autocorrect="off" autocapitalize="none" v-model="username" :rules="usernameRules" label="Username" required> </v-text-field>
          <v-text-field autocorrect="off" autocapitalize="none" type="password" v-model="password" :rules="passwordRules" label="Password" required> </v-text-field>
          <v-text-field autocorrect="off" autocapitalize="none" type="password" v-model="passwordConfirm" :rules="passwordRules" label="Confirm Password" required> </v-text-field>
          <v-select v-model="county" :items="countyList" :rules="countyRules" label="Default County" data-vv-name="select" required></v-select>
          <v-checkbox :rules="termsRules" label="I agree with Terms" required></v-checkbox>
          <v-btn id="signup-button" :disabled="!valid" color="success" @click="signup(firstname, lastname, email, phone, zipcode, whoRU, username, password, passwordConfirm, county)">Create an Account</v-btn>
        </v-form>
        <a href="https://www.termsandconditionsgenerator.com/live.php?token=v0K5rrvmIhgTYjlwUd9oRPKYOeFVcAsO" class="subheading mx-3" target="_blank">Terms and Conditions</a>
        <a href="https://www.termsfeed.com/live/926dfccc-2107-44ab-8f5e-b2a3a65a8f6a" class="subheading mx-3" target="_blank">Privacy Policy</a>
      </div>
          <center>
          <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
        </center>
    </v-app>
    <v-snackbar :color="snackbar.color" v-model="snackbar.show" timeout="3000">
      {{ snackbar.message }} 
      <v-btn text @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>


<script>
export default {
  data: () => ({
    name: 'Signup',
    valid: false,
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    zipcode: '',
    whoRU: '',
    username: '',
    password: '',
    passwordConfirm: '',
    county: '',
    whoRUitems: ["Paid Firefighter", "Volunteer Firefighter", "EMS Provider", "Police Officer", "Rubbernecker"],
    countyList: [],
    loading: false,
    snackbar: {
      show: false,
      message: null,
      color: "primary"

    },
    firstnameRules: [
        v => !!v || 'First Name is Required',
      ],
    lastnameRules: [
        v => !!v || 'Last Name is Required',
      ],
    emailRules: [
        v => !!v || 'Email address is required',
        v => /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Email must be valid'
      ],
    phoneRules: [
        v => !!v || 'Phone number is Required',
        v => /^\d{10}$/.test(v) || 'Phone number must be valid'
      ],
    zipcodeRules: [
        v => !!v || 'Zip Code is Required',
        v => /^\d{5}$/.test(v) || 'Zip code must be valid'
      ],
    whoRUrules: [
        v => !!v || 'Select an option from the list',
      ],
    usernameRules: [
        v => !!v || 'Username is Required',
        v => /^[a-zA-Z0-9]+$/.test(v) || 'Please enter a valid username. Usernames can only contain letters and numbers.'
      ],
    passwordRules: [
        v => !!v || 'Password is Required',
        v => /^.{6,}/.test(v) || 'Password must contain at least 6 characters'
      ],
    termsRules: [
        v => !!v || 'You must agree to continue!'
      ],
    countyRules: [
        v => !!v || 'Select an option from the list',
      ]
    }),
  async created(){
    if (localStorage.username){
      this.$router.push('watchlist')
      return
    }


    this.loading = true;

    const supportedAreaRequest = await fetch(localStorage.apiURL + "/app/area-supported",{
      method: "GET",
      headers: {"deviceID": "signup-page"}
    })
    const supportedAreaResponse = await supportedAreaRequest.json();

    if (!supportedAreaResponse.success){
      this.error("An error has occured, please try again");
      this.loading = false;
      return
    }
    this.countyList = supportedAreaResponse.areaArray;
    this.loading = false;
  },
  methods: {
    error(message){
      this.snackbar.show = true;
      this.snackbar.message = message;
      this.snackbar.color = "error";
    },
    async signup(firstname, lastname, email, phone, zipcode, whoRU, username, password, passwordConfirm, county){    
      console.log(firstname, lastname, email, phone, zipcode, whoRU, username, password, passwordConfirm, county)
      if (!this.$refs.signup.validate()){
        this.error("There is an error in the create account form");
        return
      }
      this.loading = true;

      if (password != passwordConfirm){
        this.loading = false;
        this.error("Passwords do not match. Try again")
        return
      }

      const response = await fetch(localStorage.apiURL + "/app/email-exists-check", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          emailFromUser: email
        })
      })
      const responseData = await response.json()
      if (!responseData.success){
        this.loading = false
        this.error("This email address is already registered. Please use a different email address")
        return
      }
      let phoneNumber = parseInt(phone);
      let zipNumber = parseInt(zipcode);

      const createAccountRequest = await fetch(localStorage.apiURL + "/app/create-user", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          firstname: firstname,
          lastname: lastname,
          emailAddress: email,
          phone: phoneNumber,
          zip: zipNumber,
          whoRU: whoRU,
          password: password,
          county: county,
          username: username
        })
      })
      const createAccountResponse = await createAccountRequest.json()

      if (!createAccountResponse.success){
        if (createAccountResponse.msg == 'username'){
          this.error("Username already taken. Please choose a different username");

        }else if (createAccountResponse.msg == 'phone'){
          this.error("Phone number already registered. Please use a different phone number");

        } else {
          this.error("An error occured: " + createAccountResponse.msg + ". Please try again");

        }
        this.loading = false;
        return;
      }

      this.loading = false;

      alert("Success! Your account has been created. You may now log in.")

      this.$router.push('login')
    },
  }
}
</script>

<style scoped>
@media screen and (max-width: 1000px) {
  #signup-form {
    margin-top: 25px;
    margin-left: 20px;
    margin-right: 20px;
    align-content: center;
  }
}
@media screen and (min-width: 1000px) {
  #signup-form {
    margin-top: 25px;
    margin-left: 25%;
    align-content: center;
    width: 50%
  }
}
#signup-header {
  text-align: center;
}
#signup-button {
  margin-bottom: 25px;
}
</style>